import { render, staticRenderFns } from "./noticeMessage.vue?vue&type=template&id=226d5a57&scoped=true"
import script from "./noticeMessage.vue?vue&type=script&lang=js"
export * from "./noticeMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226d5a57",
  null
  
)

export default component.exports